import gql from 'graphql-tag'

export const GET_REPORT_MANAGEMENT_DRIVER = gql`
  query ReportManagementDriver($filter: ReportManagementDriverFilter) {
    reportManagementDriver(filter: $filter) {
      isSuccessful
      message
      reportManagementDriver {
        totalDistance
        totalTimeTrip
        totalTimeTripStop
        totalTimeTripFormatted
        totalTimeTripStopFormatted
        driver
      }
    }
  }
`

export const GET_REPORT_MANAGEMENT_VEHICLE = gql`
  query ReportManagementVehicle($filter: ReportManagementVehicleFilter) {
    reportManagementVehicle(filter: $filter) {
      isSuccessful
      message
      reportManagementVehicle {
        vehicle
        vehicleType
        fuelEficiency
        totalEficiency
        totalMoving
        totalAssisted
        totalHourMoving
        totalTimeTripStop
        totalHourAssisted
        totalHourMovingFormatted
        totalTimeTripStopFormatted
        totalHourAssistedFormatted
        averageSpeed
      }
    }
  }
`
export const GET_REPORT_HISTORY_FLEET = gql`
  query ReportVehicleTrip($filter: ReportVehicleTripFilter) {
    reportVehicleTrip(filter: $filter) {
      isSuccessful
      message
      reportVehicleTrips{
        reportVehicleTrips {
          eficiency
          averageSpeed
          totalTimeTrip
          totalHourStop
          reportVehicleTrip {
            vehicle {
              licensePlate
              driver1 {
                fullname
              }
              driver2 {
                fullname
              }
              vehicleType {
                manufacturer
                model
                type
              }
            }
            tripMileage
            startTime
            maxSpeed
            startLong
            startLat
            stopLong
            stopLat
            stopTime
            vehicleId
            driverId
            startAddress
            stopAddress
          }
        }
        pagination {
          page
          show
          total
        }
        reportVehicleTripDataTotal {
          totalTripMileage
          totalTimeTrip
          totalTimeTripStop
          totalEfficiency
          averageSpeed
          totalDayFilter
        }
      }
    }
  }
`

export const GET_REPORT_DETAIL_HISTORY_FLEET = gql`
  query ReportDetailVehicleTrip($filter: ReportDetailVehicleTripFilter) {
    reportDetailVehicleTrip(filter: $filter) {
      isSuccessful
      message
      reportDetailVehicleTrips {
        pagination{
          page
          show
          total
        }
        data{
          driver {
            fullname
          }
          reportDetailVehicleTrip {
            latitude
            longitude
            speed
            sentOn
            address
            vehicle {
              licensePlate
              vehicleType {
                model
                type
                manufacturer
              }
            }
          }
        }
      }
    }
  }
`
export const GET_REPORT_SUMMARY_DAY_BY_VEHICLE = gql`
  query ReportSummaryDayVehicle($filter: ReportSummaryDayVehicleFilter) {
    reportSummaryDayVehicle(filter: $filter) {
      isSuccessful
      message
      ReportSummaryDayVehicle {
        companyId
        vehicleId
        driverId
        day
        harshBrakes
        harshAccels
        sharpTruns
        overSpeeds
        totalMinutes
        totalFuel
        totalMoving
        totalAssisted
        totalHourMoving
        totalHourAssisted
        totalHourTripStop
        totalHourMovingFormatted
        totalHourAssistedFormatted
        totalHourTripStopFormatted
        vehicle {
          licensePlate
          vehicleType {
            manufacturer
            model
            type
            category
          }
        }
        driver {
          fullname
        }
      }
    }
  }
`

export const GET_REPORT_SUMMARY_MONTH_BY_VEHICLE = gql`
  query SummaryMonthByVehicle($filter: ReportSummaryMonthVehicleFilter) {
    SummaryMonthByVehicle(filter: $filter) {
      isSuccessful
      message
      ReportSummaryMonthVehicle {
        data {
          companyId
          vehicleId
          licensePlate
          area
          vehicleType
          distance
          workDays
          workHours
          workHoursAvg
          parkingHours
          movingHours
          movingWorkHours
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const GET_REPORT_SUMMARY_DAY_BY_DRIVER = gql`
  query ReportSummaryDayDriver($filter: ReportSummaryDayFilter) {
    reportSummaryDayDriver(filter: $filter) {
      isSuccessful
      message
      ReportSummaryDayDriver {
          companyId
          vehicleId
        driverId
        day
        harshBrakes
        harshAccels
        totalMinutes
        totalFuel
        totalDistance
        totalHourTrip
        totalHourTripStop
        totalHourTripFormatted
        totalHourTripStopFormatted
        driver {
          fullname
        }
        vehicle {
          licensePlate
          vehicleType {
            manufacturer
            model
            type
            category
        }
        }
      }
    }
  }
`

export const GET_REPORT_SUMMARY_STOPPED = gql`
  query ReportSummaryStopped($filter: ReportSummaryStoppedFilter) {
    reportSummaryStopped(filter: $filter) {
      isSuccessful
      message
      reportSummaryStopped {
        startTime
        stopTime
        vehicleId
        vehicle {
          licensePlate
          vehicleType {
            manufacturer
            model
            type
            category
          }
        }
        driverId
        driver {
          fullname
        }
        totalSeconds
        timeStopFormatted
        longitude
        latitude
        address
      }
    }
  }
`

export const GET_REPORT_EXCESSIVE_IDLE = gql`
  query ReportExcessiveIdle($filter: ReportExcessiveIdleFilter) {
    reportExcessiveIdle(filter: $filter) {
      isSuccessful
      message
      reportExcessiveIdle {
        data {
          driver {
            fullname
          }
          address
          driverId
          latitude
          longitude
          startTime
          stopTime
          timeStopFormatted
          totalSeconds
          vehicle {
            licensePlate
            vehicleType {
              manufacturer
              model
              type
            }
          }
          vehicleId
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_REPORT_GEOLOCATION = gql`
  query VehicleGeofenceHist($filter: GetVehicleGeofenceHistFilter) {
    vehicleGeofenceHist(filter: $filter) {
      isSuccessful
      message
      vehicleGeofenceHist {
        vehicleId
        vehicle {
          licensePlate
          vehicleType {
            model
            manufacturer
            type
            category
          }
        }
        geofenceId
        geofence
        transitOn
        inside
        driver {
          fullname
        }
      }
    }
  }
`

export const GET_REPORT_SUMMARY_GEOLOCATION = gql`
  query SummaryVehicleGeofenceHist($filter: GetSummaryVehicleGeofenceHistFilter) {
    summaryVehicleGeofenceHist(filter: $filter) {
      isSuccessful
      message
      summaryVehicleGeofenceHist {
        outTime
        inTime
        vehicleId
        vehicle {
          licensePlate
          vehicleType {
            manufacturer
            model
            type
            category
          }
        }
        geofenceId
        geofence
        inside
        duration
        driver {
          fullname
        }
      }
    }
  }
`

export const GET_REPORT_ALERT = gql`
  query Data($filter: GetRawAlertFilter) {
    reportAlert(filter: $filter) {
      reportAlert {
        data {
          createdOn
          vehicleId
          alertCode
          driverId
          alertFlag
          alertData
          latitude
          longitude
          alertTrigger
          threshold
          cost
          address
          vehicle {
            licensePlate
            vehicleType {
              model
              manufacturer
              type
              category
            }
          }
          alert {
            alertCode
            descriptionEng
            descriptionIdn
          }
          driver {
            fullname
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
      isSuccessful
      message
    }
  }
`

export const GET_REPORT_DOOR = gql`
  query ReportDoor($filter: GetReportDoorFilter) {
    reportDoor(filter: $filter) {
      isSuccessful
      message
      reportDoor {
        doorOpenedOn
        doorClosedOn
        vehicleId
        vehicle {
          licensePlate
          vehicleType {
            model
            manufacturer
            type
            category
          }
        }
        driver {
          fullname
        }
        latitude
        longitude
        address
        doorSensor
        duration
      }
    }
  }
`

export const GET_REPORT_RAW_SENSOR = gql`
  query RawSensorInfos($filter: GetRawSensorInfoFilter) {
    rawSensorInfos(filter: $filter) {
      isSuccessful
      message
      rawSensorInfos {
        createdOn
        vehicleId
        vehicle {
          licensePlate
          vehicleType {
            manufacturer
            model
            category
            type
          }
        }
        fuel
        temperature
        temperature2
        temperature3
        loadSensor
        speed
        address
        door1
        door2
      }
    }
  }
`

export const GET_REPORT_FUEL = gql`
  query ReportFuel($filter: GetReportFuelFilter) {
    reportFuel(filter: $filter) {
      isSuccessful
      message
      reportFuel {
        address
        createdOn
        fuel
        fuelPercentage
        speed
        vehicle {
          boxType
          carrosserie
          companyId
          id
          driver1Id
          driver2Id
          garageId
          tonnage
          volume
          fuelEfficiency
          fuelCapacity
          odometer
          status
          imei
          licensePlate
          vehicleType {
            vehicleTypeId
            companyId
            isActive
            manufacturer
            model
            transmissionType
            tonnage
            type
            volume
            hasRelation
            fuelType
            category
          }
          vehicleTypeId
          thermoType
          year
          machineNumber
          vehicleDocs {
            licensePlate
            status
            validUntil
            vehicleId
            docType
            docNumber
          }
          garage {
            address
            category
            addressDetail
            fenceName
            geofenceId
            companyId
          }
          chassisNumber
          company {
            id
          }
        }
      }
    }
  }
`

export const DELETE_DOWNLOAD_HISTORY = gql`
  mutation DeleteDownloadHistory($filter: UpdateDownloadHistoriesFilter) {
    deleteDownloadHistory(filter: $filter) {
      isSuccessful
      message
    }
  }
`

export const RELOAD_DOWNLOAD_HISTORY = gql`
  mutation RedownloadDownloadHistory($filter: RedownloadDownloadHistoriesFilter) {
    redownloadDownloadHistory(filter: $filter) {
      isSuccessful
      message
      redownloadDownloadHistory {
        base64
      }
    }
  }
`

export const GET_REPORT_TIME_WINDOW = gql`
  query ReportTimeWindow($filter: GetReportTimeWindowFilter) {
    reportTimeWindow(filter: $filter) {
      isSuccessful
      message
      reportTimeWindow {
        data {
          data {
            doorClose
            doorOpen
            geofence {
              address
              addressDetail
              circData
              category
              city
              companyId
              contactName
              fenceName
              geofenceId
              hasRelation
              isGarage
              isServiceLoc
              phoneNo
              polyData
              postalCode
              province
              serviceLocType
              type
            }
            geofenceId
            timeBetweenGeofence
            timeInGeofence
            timeInQueue
            timeLoading
            timeOutQueue
            transitOn
            transitOnOut
            vehicleId
          }
          in
          out
          time
        }
      }
    }
  }
`

export const GET_DOWNLOAD_HISTORIES = gql`
  query DownloadHistory($filter: DownloadHistoriesFilter) {
    downloadHistory(filter: $filter) {
      isSuccessful
      message
      downloadHistory {
        companyId
        userId
        title
        startDate
        endDate
        downloadOn
        typeCode
        filter
        url
        status
      }
    }
  }
`

export const GET_REPORT_DAILY_VEHICLE_MONITORING = gql`
  query ReportDailyVehicleMonitoring($filter: ReportDailyVehicleFilter) {
    reportDailyVehicleMonitoring(filter: $filter) {
      isSuccessful
      message
      reportDailyVehicles {
        data {
          reportDailyVehicle {
            vehicle {
              licensePlate
              vehicleType {
                manufacturer
                model
                type
              }
            }
            tripMileage
            startTime
            stopTime
            stopAddress
            startAddress
          }
          eficiency
          averageSpeed
          totalTimeTrip
          totalHourStop
          vehicleHub
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_REPORT_DRIVER_SCORES = gql`
  query ReportDriverScores($filter: GetDriverScoreFilter) {
    reportDriverScores(filter: $filter) {
      isSuccessful
      message
      reportDriverScores {
        data {
          companyId
          driverId
          driver {
            userId
            fullname
          }
          year
          month
          score
          totalDriven
          totalHours
          harshBrakes
          harshAccels
          sharpTurns
          overspeeds
          baseScore
          costBrake
          costAccel
          costSharpturn
          costOverspeed
          totalBonus
          finalGrade
          totalCost
          period
          idleViolation
          restViolation
          drivingViolation
          alerts {
            alertCode
            driverId
            alertFlag
            alertData
            latitude
            longitude
            alertTrigger
            threshold
            alert {
              alertCode
              descriptionEng
              descriptionIdn
            }
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_REPORT_VEHICLE_OUTSIDE_GEOFENCE = gql`
  query ReportVehicleOutsideGeofence($filter: GetSummaryVehicleOutsideGeofenceFilter) {
  summaryVehicleOutsideGeofence(filter: $filter) {
    isSuccessful
    message
    summaryVehicleOutsideGeofence {
      pagination {
        page
        show
        search
        sortBy
        sortType
        total
      }
      data {
        duration
        geofence
        inTime
        licensePlate
        outTime
        vehicleType
        visitedGeofence
        vehicleManufacturer
        vehicleModel
      }
    }
  }
}
`

export const GET_DRIVER_BEHAVIOR_REPORT = gql`
  query DriverBehaviorReport($filter: GetRawAlertFilter) {
  reportDriverBehaviour(filter: $filter) {
    isSuccessful
    message
    reportDriverBehaviour {
      pagination {
        page
        search
        show
        total
      }
      data {
          createdOn
          alertFlag
          vehicle {
            licensePlate
            vehicleType {
              model
              manufacturer
              type
              category
            }
          }
          alert {
            alertCode
            descriptionEng
            descriptionIdn
          }
          driver {
            fullname
          }
        address
        alertData
      }
    }
  }
}
`

export const GET_REPORT_ESTIMATION_FUEL_USAGE = gql`
query ReportEstimationFuelUsage($filter: GetReportEstimationFuelUsageFilter) {
  reportEstimationFuelUsage(filter: $filter) {
    isSuccessful
    message
    reportEstimationFuelUsage {
      data {
        vehicle {
          licensePlate
          fuelEfficiency
        }
        startAddress
        endAddress
        startTime
        stopTime
        tripMileage
        ratio
        fuelUsage
      }
      pagination {
        page
        show
        total
      }
    }
  }
}
`
